import { useEffect, useRef, useState, type ReactNode } from "react";
import { Check, Copy, Loader2 } from "lucide-react";

interface CodeBlockProps {
  children: ReactNode;
  className?: string;
}

export const CodeBlock = ({ children, className }: CodeBlockProps) => {
  const [status, setStatus] = useState<"idle" | "copying" | "copied" | "error">("idle");
  const resetTimer = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => () => clearTimeout(resetTimer.current), []);
  const language = className?.replace("language-", "") || "code";

  const handleCopy = async () => {
    clearTimeout(resetTimer.current);
    setStatus("copying");
    try {
      await navigator.clipboard.writeText(String(children).replace(/\n$/, ""));
      setStatus("copied");
      resetTimer.current = setTimeout(() => setStatus("idle"), 2000);
    } catch {
      setStatus("error");
    }
  };

  return <div className="pf-journal-code"><header><span>{language}</span><button type="button" onClick={handleCopy} disabled={status === "copying"} aria-label="Copier le code">{status === "copying" ? <Loader2 className="pf-spinner" size={15} aria-hidden="true" /> : status === "copied" ? <Check size={15} aria-hidden="true" /> : <Copy size={15} aria-hidden="true" />}{status === "copied" ? "Copié !" : status === "copying" ? "Copie…" : "Copier"}</button></header><pre><code className={className}>{children}</code></pre><p role="status" aria-live="polite">{status === "error" ? "Impossible de copier. Sélectionnez le code pour le copier manuellement." : status === "copied" ? "Code copié dans le presse-papier." : ""}</p></div>;
};

export const InlineCode = ({ children }: { children: ReactNode }) => <code className="pf-journal-inline-code">{children}</code>;
